import React from 'react'
import PropTypes from 'prop-types'
import MaleDailyBanner from '../banner'
import MaleDailyArticles from '../articles'
import MaleDailyVideo from '../video'

const MaleDailyContent = ({ isMobile, videos, articles }) => {
  return (
    <>
      <MaleDailyBanner isMobile={isMobile} />

      <div
        style={{
          height: isMobile ? 'var(--space-20)' : 'var(--space-80)',
        }}
      />

      <MaleDailyArticles articles={articles} isMobile={isMobile} />

      <div
        style={{
          height: isMobile ? 'var(--space-32)' : 'var(--space-80)',
        }}
      />

      <MaleDailyVideo videos={videos} isMobile={isMobile} />

      <div style={{ height: 'var(--space-80)' }} />
    </>
  )
}

MaleDailyContent.propTypes = {
  isMobile: PropTypes.bool,
  videos: PropTypes.any,
  articles: PropTypes.any,
}

export default MaleDailyContent
